import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NrrConvertedTwoController from "./nrr_converted_two_controller"
application.register("nrr-converted-two", NrrConvertedTwoController)
